<template>
  <div>
    <div v-bind:key="index" v-for="(placeholder, index) in form.placeholders">
      <document-placeholder
        v-model="form.placeholders[index].value"
        :placeholder="placeholder"
      ></document-placeholder>
    </div>
  </div>
</template>
<script>
import DocumentPlaceholder from './DocumentPlaceholder';

export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    incident: {
      type: String,
      required: true
    },
    thirdPartyId: {
      type: [Number, String],
      required: false
    },
    type: {
      type: String,
      required: true
    }
  },

  components: {
    DocumentPlaceholder
  },

  methods: {
    loadPlaceholders(type) {
      if (type) {
        window.Ajax.get(
          `/incidents/${this.incident}/documents/placeholders?type=${type}&third_party_id=${this.thirdPartyId}`
        ).then(response => {
          this.form.placeholders = response.data;
        });
      }
    }
  },

  watch: {
    type: {
      handler(type) {
        this.loadPlaceholders(type);
      },
      immediate: true
    },
    thirdPartyId(value) {
      this.loadPlaceholders(this.type);
    }
  }
};
</script>
